var _style, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgFacebookLogoBlue = function SvgFacebookLogoBlue(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 43 43",
    style: {
      enableBackground: "new 0 0 43 43"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{filter:url(#Adobe_OpacityMaskFilter);}\n\t.st1{fill-rule:evenodd;clip-rule:evenodd;fill:#FFFFFF;}\n\t.st2{mask:url(#mask-2_1_);fill-rule:evenodd;clip-rule:evenodd;fill:none;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols"
  }, /*#__PURE__*/React.createElement("g", {
    id: "f_logo_RGB-WHITE_1024"
  }, /*#__PURE__*/React.createElement("g", {
    id: "f_logo_RGB-Blue_1024"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Clip-2"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter",
    filterUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 43,
    height: 43
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0"
  }))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 43,
    height: 43,
    id: "mask-2_1_"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "path-1_1_",
    className: "st1",
    points: "0,0 43,0 43,43 0,43  "
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Fill-1",
    className: "st2",
    d: "M43,21.6C43,9.7,33.4,0,21.5,0S0,9.7,0,21.6C0,32.4,7.9,41.4,18.1,43V27.9h-5.5v-6.3h5.5v-4.8 c0-5.4,3.2-8.4,8.1-8.4c2.4,0,4.8,0.4,4.8,0.4v5.3h-2.7c-2.7,0-3.5,1.7-3.5,3.4v4.1h6l-1,6.3h-5V43C35.1,41.4,43,32.4,43,21.6"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Fill-4",
    className: "st1",
    d: "M29.8,28.1l0.9-6.3h-5.8v-4.1c0-1.7,0.8-3.4,3.4-3.4H31V9c0,0-2.4-0.4-4.7-0.4 c-4.8,0-7.9,3-7.9,8.5v4.8H13v6.3h5.3v15.2c1.1,0.2,2.2,0.3,3.3,0.3s2.2-0.1,3.3-0.3V28.1H29.8"
  }))))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgFacebookLogoBlue, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/facebook_logo_blue.638c7fbe.svg";
export { ForwardRef as ReactComponent };